import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonType } from './ButtonType';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { LoadingComponent } from '../loading/loading.component';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-primary-button',
  imports: [CommonModule, MatIconModule, LoadingComponent, MatRippleModule],
  templateUrl: './primary-button.component.html',
  styleUrl: './primary-button.component.css',
})
export class PrimaryButtonComponent {
  @Input({ required: true }) text: string;
  @Input() type: ButtonType = ButtonType.BASIC;
  @Input() icon: string;
  @Input() disabled = false;
  @Input() loading = false;
  @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();
  buttonType = ButtonType;

  handleClick(): void {
    this.buttonClicked.emit();
  }
}
